import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button, Grid, Divider } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { fetchBusinessUnit } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import DetailSection from "../../components/common/DetailSection";
import DetailField from "../../components/common/DetailField";

const formatDate = (iso) => {
  if (!iso) return "";
  return iso.substring(0, 10).replace(/-/g, "/");
};

export default function BuildBusinessUnitDetailPage() {
  const { businessDomainId, businessUnitId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const basePath = `/build/${businessDomainId}/business-units/${businessUnitId}`;

  const [data, setData] = useState(null);

  const loadData = useCallback(async () => {
    try { setData(await fetchBusinessUnit(businessUnitId)); }
    catch (e) { notify.apiError(e); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessUnitId]);

  useEffect(() => { loadData(); }, [loadData]);

  if (!data) return null;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("businessUnit.detail.title")}</Typography>
      </Box>

      <DetailSection>
        <Grid container spacing={2}>
          <Grid size={12} md={6}>
            <DetailField label={t("businessDomain.title")} value={data.businessDomainName} />
          </Grid>
          <Grid size={12} md={6}>
            <DetailField label={t("businessUnit.name")} value={data.businessUnitName} />
          </Grid>
          <Grid size={12}>
            <DetailField label={t("businessUnit.vision")} value={data.vision} />
          </Grid>
          <Grid size={12} md={6}>
            <DetailField label={t("businessUnit.startDate")} value={formatDate(data.startDate)} />
          </Grid>
          <Grid size={12} md={6}>
            <DetailField label={t("businessUnit.endDate")} value={formatDate(data.endDate)} />
          </Grid>
          <Grid size={12} md={6}>
            <DetailField label={t("businessUnit.url")} value={data.url} />
          </Grid>
        </Grid>
      </DetailSection>

      <Divider sx={{ my: 3 }} />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Button variant="outlined" startIcon={<ApartmentIcon />}
          onClick={() => navigate(`${basePath}/departments`)}>
          {t("department.list.title")}
        </Button>
        <Button variant="outlined" startIcon={<FolderSpecialIcon />}
          onClick={() => navigate(`${basePath}/projects`)}>
          {t("project.list.title")}
        </Button>
        <Button variant="outlined" startIcon={<ViewModuleIcon />}
          onClick={() => navigate(`${basePath}/programs`)}>
          {t("program.list.title")}
        </Button>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Button variant="outlined" onClick={() => navigate(`/build/${businessDomainId}/business-units`)}>{t("common.back")}</Button>
      </Box>
    </Box>
  );
}
